"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChevronDownCircleSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M16,9 C16,12.8659932 12.8659932,16 9,16 C5.13400675,16 2,12.8659932 2,9 C2,5.13400675 5.13400675,2 9,2 C12.8659932,2 16,5.13400675 16,9 Z M15,9 C15,5.6862915 12.3137085,3 9,3 C5.6862915,3 3,5.6862915 3,9 C3,12.3137085 5.6862915,15 9,15 C12.3137085,15 15,12.3137085 15,9 Z M10.9091229,8.15808459 C11.1103893,7.96400884 11.4294042,7.9648499 11.6296445,8.15998419 L11.634147,8.16442829 C11.8276322,8.35785825 11.827677,8.671515 11.6342471,8.86500023 L9,11.5 L6.35988726,8.86064151 C6.35684915,8.85760426 6.3538512,8.8545271 6.35089419,8.85141084 C6.16503255,8.65553907 6.17314737,8.346083 6.36901915,8.16022136 C6.57270638,7.96694368 6.89242154,7.96817035 7.09461968,8.16300531 L9,9.999 L10.9091229,8.15808459 L10.9091229,8.15808459 Z" })));
};
ChevronDownCircleSmall.displayName = 'ChevronDownCircleSmall';
exports.default = ChevronDownCircleSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChevronDownCircleSmall.js.map